import { Typography, Stack } from "@mui/material";
import ItemDto from "../../../models/ItemDto";
import SubCategoryDto from "../../../models/SubCategoryDto";
import ItemListCardItem from "./ItemListCardItem";
import CurrencyDto from "../../../models/CurrencyDto";

interface SubCategoryPageProps {
    subCategory: SubCategoryDto;
    currency: CurrencyDto;
}

export default function SubCategoryPage({ subCategory, currency }: SubCategoryPageProps) {
    return (
        <>
            <Typography
                style={{ color: 'white', marginTop: '0rem', marginBottom: '1.25rem' }}
                textAlign='left'
                align="center"
            >
                {subCategory.description}
            </Typography>
            <Stack spacing={1}>
                {subCategory.items.map((item: ItemDto, index: number) => (
                    <ItemListCardItem
                        currency={currency}
                        item={item}
                        key={"item_" + index}
                    />
                ))}
            </Stack>
        </>
    )
}